import React, { useState } from 'react';
import { Modal, Button, Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ModalComponent.css';

const API_URL = process.env.REACT_APP_API_URL || "https://apiprov.conduto.com.ec";

function ModalComponent({ onClose, idFormulario }) {
  const [show, setShow] = useState(true);
  const [isChecked, setIsChecked] = useState(false);

  const handleClose = async () => {
    if (isChecked && idFormulario) {
      try {
        await fetch(`${API_URL}/api/formularios/${idFormulario}/marcar-notificado`, {
          method: "PUT",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
        });

        await fetch(`${API_URL}/api/formularios/${idFormulario}/requisitos`, {
          method: "PUT",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ requisitos_aceptados: true }),
        });
      } catch (err) {
        console.error("Error al actualizar requisitos:", err);
      }
    }
    setShow(false);
    if (onClose) onClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      keyboard={false}
      centered
      size="lg"
      dialogClassName="custom-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Bienvenido</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container fluid>
          <Row>
            <Col xs={12}>
              <p>Antes de ingresar a la plataforma, asegúrese de tener todos estos requisitos:</p>
              <div className="scrollable-content" style={{ maxHeight: "60vh", overflowY: "auto" }}>
                <img
                  src={require('../../assets/img/requisitos.jpg')}
                  alt="Requisitos"
                  className="img-fluid mb-3"
                  style={{ width: "100%", height: "auto" }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer className="flex-wrap">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center w-100 gap-3">
          <div className="form-check">
          </div>
          <Button variant="secondary" onClick={handleClose}>
            Aceptar
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalComponent;